import { Stack } from "@mui/material";
import type { FC } from "react";
import type { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CurrencyAmount } from "web_myplann/Portfolio/Components/Redesign/ListItem/CurrencyAmount";
import { PerformanceBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/PerformanceBadge";
import {
	type PortfolioTileTrailing,
	TILE_SECONDARY_KIND,
} from "web_myplann/Portfolio/Helpers/getPortfolioTileTrailing";

type Props = {
	trailing: PortfolioTileTrailing;
	currencySign?: string;
};

export const PortfolioRowTrailing: FC<Props> = ({ trailing, currencySign }) => {
	const { t } = useResource();
	const { primary, secondary } = trailing;

	const frequencySuffix = (
		frequency: ClientPortfolioPaymentFrequencyEnum | null | undefined,
	): string | undefined => {
		const label = frequency
			? t(Resources.Portfolio.List.Redesign.PaymentFrequencyShort[frequency])
			: "";
		return label ? `/${label}` : undefined;
	};

	return (
		<Stack alignItems="flex-end" gap={0.25}>
			{primary && (
				<CurrencyAmount
					value={primary.amount}
					currencySign={currencySign}
					suffix={frequencySuffix(primary.frequency)}
				/>
			)}
			{secondary?.kind === TILE_SECONDARY_KIND.evaluation && (
				<PerformanceBadge percent={secondary.percent} />
			)}
			{secondary?.kind === TILE_SECONDARY_KIND.payment && (
				<CurrencyAmount
					value={secondary.amount}
					currencySign={currencySign}
					variant="bodyMedium"
					suffix={frequencySuffix(secondary.frequency)}
				/>
			)}
		</Stack>
	);
};
